export default __webpack_public_path__ + "static/app-2-a4ae769ebc06864cb076df5402067583.webp";